import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.sass'],
})
export class ConfirmModalComponent {
  @Input() isShowModal = false;
  @Input() title?: string;
  @Input() hideButtons?: boolean = false;
  @Input() valid?: boolean = true;
  @Output() submitHandler = new EventEmitter<boolean>();
  @Output() closeHandler = new EventEmitter<boolean>();

  close() {
    this.closeHandler.emit();
  }

  submit() {
    this.submitHandler.emit();
  }
}
